export default __webpack_public_path__ + "static/contact-bg-1cb6b5e0d3b01aebc20211d2e02fdd69.png";